export const getFrameworkBuilderMetaDataValue = (fieldName, metadata) => {
  if (metadata[fieldName] && metadata[fieldName].value !== 'null') {
    return metadata[fieldName].value;
  }
  return undefined;
};
export const getMetadataValue = metadataInstance => {
  if (metadataInstance && metadataInstance.value !== 'null') {
    return metadataInstance.value;
  }
  return undefined;
};